export { default as getGlobalHtmlAttrs, type GlobalHTMLAttrs } from './getGlobalHtmlAttrs'
export { default as getSvgPlaceholder } from './getSvgPlaceholder'
export { default as getGameDateTime } from './getGameDateTime'
export { default as getLiveTotalScore } from './getLiveTotalScore'
